











// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/administration/forfait/edit/EditActivity.vue'
import { getDefaultAloForfait, AloForfait } from '@/models/alo/AloForfait'
import { toStringDictionary } from '@/utils/groupBy'
import ListeTuilePres from '@/components/shared/ListeTuilePres.vue'
import { ITuileNav } from '@/models/ui/ITuileNav'
import { getImageUrl } from '@/utils/images'

@Component({
  name: 'ReadActivity',    
   props: {
    forfait:{      
      default:getDefaultAloForfait()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit,ListeTuilePres}
})
export default class ReadActivity extends Vue {
  private forfait!:AloForfait
  private loading!:boolean

  get activityDic(){
    return this.$store.myGetters.activityDic
  }
  

  get activityTuileList(){
    return this.forfait.acyIds.filter(acyId => !!this.activityDic[acyId]).map(id => {
      return { 
        id: id,  
        title: this.activityDic[id].libelle,
        image: this.activityDic[id].image,
        subtitle: this.activityDic[id].acyInfos,
        promo:this.activityDic[id].acyAge?`à partir de ${this.activityDic[id].acyAge} ans`:null
      } as ITuileNav
    })
  }

  get configuration(){
    return this.$store.myGetters.configuration
  }

  created(){
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
  }

  edit() { (this.$refs.edit as Edit).edit(this.forfait) }
}
